import moment from 'moment'
import React from 'react'
import {framework_tool, utils_tool, component_tool} from '@/tool'

let {WizModal} = component_tool;

import {WizClassifySelect, WizJointExhibition, WizTableForm} from '@/containers/common';
//配置项
let componentName = 'taskInfo'

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "任务名称",
    name: "name",
    dataIndex: "name",
    tableItem: {},
    formItem: {},
    searchItem: {},
  },
  {
    title: "业务类型",
    name: "bizType",
    dataIndex: "bizType",
    tableItem: {},
    dict: [
      {code: 0, codeName: "课程"},
      {code: 1, codeName: "考试"},
      {code: 26, codeName: "直播"},
      {code: 15, codeName: '报名'},
      {code: 45, codeName: '班级环节'},
      {code: 47, codeName: '远程评估'},
      {code: 20, codeName: '内容通知'},
    ],
    searchItem: {
      type: "select",
    },
  },
  {
    title: "重要程度",
    name: "importance",
    dataIndex: "importance",
    tableItem: {},
    dict: [
      {code: 0, codeName: "重要"},
      {code: 1, codeName: "一般"},
    ],
    searchItem: {
      type: "select",
    },
  },
  {
    title: "开始时间",
    name: "startDate",
    dataIndex: "startDate",
    tableItem: {},
  },
  {
    title: "结束时间",
    name: "endDate",
    dataIndex: "endDate",
    tableItem: {},
  },
  {
    title: "状态",
    name: "state",
    dataIndex: "state",
    tableItem: {},
    dict: [
      {code: 0, codeName: "未开始"},
      {code: 1, codeName: "执行中"},
      {code: 2, codeName: "已结束"},
      {code: 3, codeName: "已取消"},
    ],
    searchItem: {
      type: "select",
    },
  },
  {
    title: "任务来源",
    name: "source",
    dataIndex: "source",
    tableItem: {},
    dict: [
      {code: 0, codeName: "统一平台"},
      {code: 1, codeName: "第三方系统"},
    ],
    searchItem: {
      type: "select",
    },
  },
  {
    title: "是否消息通知",
    dict: [
      {code: 0, codeName: "否"},
      {code: 1, codeName: "是"},
    ],
    name: "needNotice",
    dataIndex: "needNotice",
    tableItem: {},
  },
  {
    title: '任务时间',
    name: 'time',
    dataIndex: 'time',
    searchItem: {
      type: 'date~'
    }
  },
  {
    title: '是否启用',
    name: 'status',
    dataIndex: 'status',
    dict: [
      {code: 1, codeName: '是'},
      {code: 0, codeName: '否'}
    ],
    searchItem: {
      type: 'select'
    },
    tableItem: {}
  },
];

const templateConfig = (e) => {
  let {_btnFun} = e;
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        searchBarProps: {
          dataFormat: (params) => {
            let value = Object.assign({}, params)
            if (value.time && value.time.length === 2) {
              value.startDate = moment(value.time[0]).format('YYYY-MM-DD HH:mm:ss')
              value.endDate = moment(value.time[1]).format('YYYY-MM-DD HH:mm:ss')
            }
            // delete value.time
            return value
          },
          buttonSort: ['add', 'export', 'taskNotificationManagement'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: {icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            },
            {
              key: 'add',
              custom: true,
              params: {icon: 'plus', children: '新增', type: 'primary'},
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/taskInfo/add'
                }
              }
            },
            {
              key: 'taskNotificationManagement',
              name: 'WizButton',
              params: { children: '任务通知管理',key: '_btn'},
              onClick: (e) => _btnFun && _btnFun(e)
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          loading: false
        },

        rowOperateSort: ['update', 'enableOrCancelTask', 'taskRecord'],
        rowOperateView: [
          {
            key: "enableOrCancelTask",
            custom: true,
            params: {children: "启用"},
            textFormat: {
              recordKey: 'state',
              dirt: {0: '取消任务', 1: '取消任务', 2: '取消任务', 3: '启用任务'}
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "enable",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要${
                  record['state'] === 3 ? "启用任务" : "取消任务"
                }吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      state: record['state'] === 3 ? 1 : 0,
                      ids: [record['id']],
                      //...filters
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
          {
            key: "taskRecord",
            custom: true,
            params: {children: "任务记录"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/taskInfo/record"
              }
            }
          },

          {
            key: "update",
            custom: true,
            params: {children: "编辑"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/taskInfo/update"
              }
            },
          }
        ]
      }
    }
  }

};

const apis = {
  list: {
    path: `${componentName}/listByPage`,
    payload: {
      key: `${componentName}@listByPage`,
      apiParams: {pageNum: 1, pageSize: 10}
    }
  },
  export: {
    path: `${componentName}/taskList`,
    payload: {
      key: `${componentName}@taskList`,
      apiParams: {}
    }
  },
  add: {
    path: `${componentName}/add`,
    payload: {
      key: `${componentName}@add`,
      apiParams: {}
    }
  },
  update: {
    path: `${componentName}/update`,
    payload: {
      key: `${componentName}@update`,
      apiParams: {}
    }
  },
  enable: {
    path: `${componentName}/enable`,
    payload: {
      key: `${componentName}@enable`,
      apiParams: {}
    }
  },

}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export {reduxTemplateCofig, templateConfig};
